/**
 * Utility functions for handling image URLs in development and production
 */

/**
 * Transforms CloudFront image URLs to use local proxy in development
 * @param imageUrl The original image URL
 * @returns The transformed URL for the current environment
 */
export function transformImageUrlForEnvironment(imageUrl: string): string {
    // Check if we're in development (localhost)
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
        // Check if this is a CloudFront URL
        if (imageUrl.includes('d1yki1szmujy0z.cloudfront.net')) {
            // Transform CloudFront URL to use local proxy
            const url = new URL(imageUrl);
            return `/cloudfront-images${url.pathname}${url.search}${url.hash}`;
        }
    }
    
    // Return original URL for production or non-CloudFront URLs
    return imageUrl;
}

/**
 * Transforms multiple image URLs for the current environment
 * @param urls Object containing image URLs
 * @returns Object with transformed URLs
 */
export function transformImageUrlsForEnvironment<T extends Record<string, string | null | undefined>>(urls: T): T {
    const transformed = {} as T;
    
    for (const [key, url] of Object.entries(urls)) {
        if (url) {
            (transformed as any)[key] = transformImageUrlForEnvironment(url);
        } else {
            (transformed as any)[key] = url;
        }
    }
    
    return transformed;
}
